import { render, staticRenderFns } from "./Solicitud2.vue?vue&type=template&id=06c7be73&"
import script from "./Solicitud2.vue?vue&type=script&lang=js&"
export * from "./Solicitud2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports